export enum RegisterStates {
  B2CREGISTER_UNSUCCESSFUL = 'B2CRegisterUnsuccessful',
  LOYALTY_REGISTER_UNSUCCESSFUL = 'LoyaltyRegisterUnsuccessful',
  LOYALTY_UPDATE_UN_SUCCESSFUL = 'LoyaltyUpdateUnSuccessful',
  SUCCESS = 'Success',
}
